import React, { useEffect, useState,useRef } from "react";
import { Box, Drawer, IconButton, Button,CircularProgress } from "@mui/material";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import profilecross from "../../../assets/profilecross.svg";
import save from "../../../assets/save.svg";
import { BASE_URL } from "../../../components/BaseUrl";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../Utlis/Encryption";
import { useTranslation } from "react-i18next";
const AbsenceFilterDrawer = ({ open, onClose, onApply }) => {
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
const [typesLoading, setTypesLoading] = useState(false);
  const [types, setTypes] = useState([]);
    const startRef = useRef(null);
    const endRef = useRef(null);
  const [filters, setFilters] = useState({
    absence_type: "",
    start_date: "",
    end_date: "",
  });
const {t}=useTranslation()
  // Fetch absence types
  const fetchTypes = async () => {
    try {
        setTypesLoading(true);
      const res = await fetch(`${BASE_URL}/absences/admin/absences/types`, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });
      const json = await res.json();
      console.log("Fetched Absence Types:", json);
      if (!json.error) {
        setTypes(json.data.absenceTypes);
      }
    } catch (err) {
      console.log("Types Fetch Error:", err);
    }
     finally {
    setTypesLoading(false);
  }
  };

  useEffect(() => {
    if (open) fetchTypes();
  }, [open]);

  // const applyFilters = () => {
  //   onApply(filters);
  //   onClose();
  // };
  const applyFilters = () => {
  console.log("APPLY FILTERS CLICKED");
  console.log("Filters before sending to parent:", filters);

  onApply(filters);
  onClose();
};

  const clearFilters = () => {
    const empty = { absence_type: "", start_date: "", end_date: "" };
    setFilters(empty);
    onApply(empty);
    onClose();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: 400, md: 450 },
          backgroundColor: "#E7EBEE",
        },
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          px: 2,
          py: 2,
          display: "flex",
          alignItems: "center",
          gap: 1,
          backgroundColor: "#E7EBEE",
        }}
      >
        <IconButton onClick={onClose}>
          <img src={profilecross} alt="close" />
        </IconButton>

        <CustomText
          sx={{
            ...textStyles.h1,
            fontSize: 20,
            fontWeight: 600,
            color: "#2C384C",
          }}
        >
     {t("absence.filter.heading")}
        </CustomText>
      </Box>

      {/* BODY */}
      <Box sx={{ px: 2 }}>
        <Box
          sx={{
            backgroundColor: "white",
            px: 3,
            py: 3,
            height: "calc(100vh - 90px)",
            overflowY: "auto",
          }}
        >
          {/* ABSENCE TYPE */}
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 18,
              fontWeight: 500,
              color: "#2C384C",
              pt: 1,
              textAlign:"left"
            }}
          >
         {t("absence.filter.absence_type")}
          </CustomText>

   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
  {typesLoading ? (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", py: 2 }}>
      <CircularProgress size={24} />
    </Box>
  ) : (
    types.map((t) => {
      const selected = filters.absence_type === t.code;

      return (
        <Button
          key={t.id}
          variant="outlined"
          size="small"
          onClick={() =>
            setFilters((prev) => ({
              ...prev,
              absence_type: selected ? "" : t.code,
            }))
          }
          sx={{
            borderRadius: "6px",
            fontSize: "14px",
            textTransform: "none",
            px: 2,
            py: 0.7,
            border: selected
              ? "2px solid #006EC2"
              : "2px solid #091E4224",
            color: selected ? "#006EC2" : "#363333",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          {t.name}
        </Button>
      );
    })
  )}

</Box>

          {/* DATE RANGE */}
          <Box sx={{ mt: 4 }}>
            <label className="field_label"> {t("absence.filter.start_date")}</label>
            <input
             ref={startRef}
                onClick={() => startRef.current?.showPicker()} 
              type="date"
              value={filters.start_date}
              onChange={(e) =>
                setFilters((prev) => ({
                  ...prev,
                  start_date: e.target.value,
                }))
              }
              className="project_input"
              style={{ width: "100%", height: 40 }}
            />
          </Box>

          <Box sx={{ mt: 3 }}>
            <label className="field_label"> {t("absence.filter.end_date")}</label>
            <input
             ref={endRef}
                onClick={() => endRef.current?.showPicker()} 
              type="date"
              value={filters.end_date}
              onChange={(e) =>
                setFilters((prev) => ({
                  ...prev,
                  end_date: e.target.value,
                }))
              }
              className="project_input"
              style={{ width: "100%", height: 40 }}
            />
          </Box>

          {/* BUTTONS */}
          <Box sx={{ mt: 4, display: "flex", gap: 2 }}>
            <CustomButton
              size="medium"
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img src={save} alt="" width={16} />
                 {t("absence.filter.apply")}
                </Box>
              }
              onClick={applyFilters}
            />

            <Button
              variant="outlined"
              onClick={clearFilters}
              sx={{
                fontSize: 15,
                textTransform: "none",
                borderRadius: "5px",
                color: "#006EC2",
                border: "2px solid #006EC2",
                px: 3,
                 fontFamily: 'Poppins, sans-serif',
              }}
            >
            {t("absence.filter.clear")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default AbsenceFilterDrawer;
